const ENV = 'uat';
// const ENV = 'prod';

const CLIENT = 'india';
// const CLIENT = 'nepal';

const IS_INDIA = CLIENT === 'india';
const IS_NEPAL = CLIENT === 'nepal';

const API_CONFIG = {
    india: {
        auto: {
            uat: 'https://autouatapi.acrossassist.in/api/Auto/',
            prod: 'https://autoapi.acrossassist.com/api/Auto/',
        },
        financeVendor: {
            uat: 'https://tmagadgetapi.acrossassist.in/api/FinanceVendor/',
            prod: 'https://gadgetapi.acrossassist.com/api/FinanceVendor/',
        },
        techfinance: {
            uat: 'https://financeuatapi.acrossassist.in/api/Auto',
            prod: 'https://financeportalapi.acrossassist.com/api/Auto',
        },
    },

    nepal: {
        auto: {
            uat: 'https://YOUR-NEPAL-AUTO-UAT-URL/api/Auto/',
            prod: 'https://YOUR-NEPAL-AUTO-PROD-URL/api/Auto/',
        },
        financeVendor: {
            uat: 'https://YOUR-NEPAL-FINANCE-UAT-URL/api/FinanceVendor/',
            prod: 'https://YOUR-NEPAL-FINANCE-PROD-URL/api/FinanceVendor/',
        },
        techfinance: {
            uat: 'https://YOUR-NEPAL-TECHFINANCE-UAT-URL/api/Auto/',
            prod: 'https://YOUR-NEPAL-TECHFINANCE-PROD-URL/api/Auto/',
        },
    },
};

export const baseURLAuto = API_CONFIG[CLIENT].auto[ENV];
export const baseURLFinanceVendor = API_CONFIG[CLIENT].financeVendor[ENV];
export const baseURLTechFinance = API_CONFIG[CLIENT].techfinance[ENV];

export const isIndia = IS_INDIA;
export const isNepal = IS_NEPAL;

const config = {
    baseURLAuto,
    baseURLFinanceVendor,
    baseURLTechFinance,
    isIndia: IS_INDIA,
    isNepal: IS_NEPAL,
};

export default config;